"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const OsmosysIcon_1 = require("../../art/OsmosysIcon");
const react_if_1 = require("react-if");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const OsmosysAlert_1 = require("../../ui/OsmosysAlert");
const overlays_1 = require("../../overlays");
const react_router_dom_1 = require("react-router-dom");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const hooks_1 = require("../../../hooks");
const index_1 = require("../index");
const utils_1 = require("../../utils");
const react_hanger_1 = require("react-hanger");
const Cols = ({ left, right, }) => {
    return (react_1.default.createElement("div", { className: "flex-row" },
        react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true }, left),
        react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true }, right)));
};
exports.OsmosysButton = originalProps => {
    const osysStyleObj = index_1.OSMOSYS_BUTTON_PRESETS[originalProps.osysStyle || 'default'];
    const _a = Object.assign(Object.assign({}, osysStyleObj), originalProps), { style, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    inactiveClassName, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    activeClassName, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    full, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    query, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    centered, active, size, replace, blurOnClick, openInNewTab, href, children, childrenWhileDisabled, mutate, mutationResult, osysIcon, faIcon, faProps, iconSpin, iconSize, iconStyle, iconFixedWidth, iconPosition = 'left', queryResult, preventDefault, onClick, osysName, disabled, tooltip, renderApolloError = !!originalProps.mutationResult, errorPrefix, to, confirm, inline, opacity, osysStyle, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    errorStickyMs = 5000, successStickyMs = 2000, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loadingStickyMs = 500, color, flexColCenteredTooltip } = _a, props = tslib_1.__rest(_a, ["style", "inactiveClassName", "activeClassName", "full", "query", "centered", "active", "size", "replace", "blurOnClick", "openInNewTab", "href", "children", "childrenWhileDisabled", "mutate", "mutationResult", "osysIcon", "faIcon", "faProps", "iconSpin", "iconSize", "iconStyle", "iconFixedWidth", "iconPosition", "queryResult", "preventDefault", "onClick", "osysName", "disabled", "tooltip", "renderApolloError", "errorPrefix", "to", "confirm", "inline", "opacity", "osysStyle", "errorStickyMs", "successStickyMs", "loadingStickyMs", "color", "flexColCenteredTooltip"]);
    // A ref to use later
    const ref = react_1.useRef(null);
    // Computed values
    let computedDisabled = disabled;
    let computedOsysIconProps = {
        fixedWidth: iconFixedWidth,
        iconStyle: iconStyle,
        osysIcon,
        size: iconSize,
        spin: iconSpin,
    };
    if (!osysIcon && typeof props.toggledIcon === 'boolean') {
        if (props.toggledIcon) {
            computedOsysIconProps.osysIcon = 'toggleOn';
        }
        else {
            computedOsysIconProps.osysIcon = 'toggleOff';
        }
    }
    // Mutation info
    const isMutationButton = !!(mutationResult && mutate);
    const mutationHasErrored = !!(mutationResult && mutationResult.error);
    const mutationHasData = !!(mutationResult && mutationResult.data);
    const mutationIsLoading = !!(mutationResult && mutationResult.loading);
    // Sticky mutation states:
    const [stickiedSuccess, triggerStickiedSuccess] = hooks_1.useOsmosysSlingshot(successStickyMs, true, false);
    const [stickiedError, triggerStickiedError] = hooks_1.useOsmosysSlingshot(successStickyMs, true, false);
    const prevMutationHasData = react_hanger_1.usePrevious(mutationHasData);
    const prevMutationHasError = react_hanger_1.usePrevious(mutationIsLoading);
    react_1.useEffect(() => {
        if (!prevMutationHasData && mutationHasData) {
            triggerStickiedSuccess();
        }
    }, [prevMutationHasError, mutationHasData]);
    react_1.useEffect(() => {
        if (!prevMutationHasError && mutationHasErrored) {
            triggerStickiedError();
        }
    }, [prevMutationHasError, mutationHasErrored]);
    const buttonState = !isMutationButton
        ? undefined
        : mutationIsLoading
            ? 'loading'
            : stickiedError
                ? 'error'
                : stickiedSuccess
                    ? 'success'
                    : undefined;
    if (buttonState) {
        computedDisabled = true;
    }
    if (buttonState === 'loading') {
        computedOsysIconProps = Object.assign(Object.assign({}, computedOsysIconProps), { osysIcon: 'spinner', spin: true });
    }
    else if (buttonState === 'success') {
        computedOsysIconProps = Object.assign(Object.assign({}, computedOsysIconProps), { osysIcon: 'success' });
    }
    else if (mutationHasErrored) {
        computedOsysIconProps = Object.assign(Object.assign({}, computedOsysIconProps), { iconStyle: 'solid', osysIcon: 'exclamation' });
    }
    if (size === 'sm' && !computedOsysIconProps.size) {
        computedOsysIconProps = Object.assign(Object.assign({}, computedOsysIconProps), { size: 'sm' });
    }
    const computedChildren = buttonState === 'loading'
        ? osysStyle === 'save'
            ? 'Saving...'
            : 'Loading...'
        : buttonState === 'success'
            ? osysStyle === 'save'
                ? 'Saved'
                : 'Success'
            : computedDisabled && childrenWhileDisabled
                ? childrenWhileDisabled
                : children;
    const iconComp = faIcon ? (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: faIcon, size: computedOsysIconProps.size || undefined }, faProps))) : !computedOsysIconProps.osysIcon ? null : (react_1.default.createElement(OsmosysIcon_1.OsmosysIcon, Object.assign({ osysIcon: computedOsysIconProps.osysIcon, marginRight: computedChildren && iconPosition === 'left' ? true : 0, marginLeft: computedChildren && iconPosition === 'right' ? true : 0 }, computedOsysIconProps)));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(overlays_1.OsmosysTooltip, { span: inline, label: tooltip, off: !tooltip, divProps: {
                flexColCentered: flexColCenteredTooltip,
            } },
            react_1.default.createElement(reactstrap_1.Button, Object.assign({ target: openInNewTab && '_blank', innerRef: ref, color: color, href: href }, props, { "data-osmosys-comp": osysName, "data-osmosys-comp-base": "OsmosysButton", "data-stickied-success": stickiedSuccess, "data-stickied-error": stickiedError, disabled: computedDisabled, active: active, size: size, replace: to ? replace : undefined, tag: href ? 'a' : to ? react_router_dom_1.Link : undefined, to: to, style: Object.assign({ opacity }, style), className: classnames_1.default(
                // full,
                buttonState === 'error' && 'bg-danger', buttonState && 'progress-bar-striped progress-bar-animated', osysStyleObj.className, originalProps.className, active && osysStyleObj.activeClassName, active && originalProps.activeClassName, !active && osysStyleObj.inactiveClassName, !active && originalProps.inactiveClassName), onClick: e => {
                    if (preventDefault) {
                        e.preventDefault();
                    }
                    if (confirm) {
                        const confirmation = window.confirm('Are you sure?');
                        if (!confirmation) {
                            return;
                        }
                    }
                    if (mutate) {
                        mutate();
                    }
                    if (onClick) {
                        onClick(e);
                    }
                    if (blurOnClick) {
                        ref.current && ref.current.blur();
                    }
                } }),
                react_1.default.createElement(react_if_1.If, { condition: iconPosition === 'left' },
                    react_1.default.createElement(react_if_1.Then, null, () => react_1.default.createElement(Cols, { left: iconComp, right: computedChildren })),
                    react_1.default.createElement(react_if_1.Else, null, () => react_1.default.createElement(Cols, { right: iconComp, left: computedChildren }))))),
        react_1.default.createElement(react_if_1.When, { condition: !!(renderApolloError && (queryResult || mutationResult)) }, () => (react_1.default.createElement(OsmosysAlert_1.OsmosysAlert, { apolloError: queryResult
                ? queryResult.error
                : mutationResult
                    ? mutationResult.error
                    : undefined, floatBottom: true, dismissable: true, errorPrefix: errorPrefix })))));
};
//# sourceMappingURL=base.js.map